import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import itCommon from "./locales/it/common.json";
import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";
import frCommon from "./locales/fr/common.json";

import itViews from "./locales/it/views.json";
import enViews from "./locales/en/views.json";
import esViews from "./locales/es/views.json";
import frViews from "./locales/fr/views.json";

import itComponents from "./locales/it/components.json";
import enComponents from "./locales/en/components.json";
import frComponents from "./locales/fr/components.json";
import esComponents from "./locales/es/components.json";

const supportedLngs = ["it", "en", "es", "fr"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "it",
    supportedLngs,
    nonExplicitSupportedLngs: true,
    ns: ["common", "views", "components"],
    defaultNS: "common",
    detection: {
      order: ["navigator"], // use browser language
      caches: [],
    },
    resources: {
      it: {
        common: itCommon,
        components: itComponents,
        views: itViews,
      },
      en: {
        common: enCommon,
        components: enComponents,
        views: enViews,
      },
      es: {
        common: esCommon,
        components: esComponents,
        views: esViews,
      },
      fr: {
        common: frCommon,
        components: frComponents,
        views: frViews,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
